export const togglePopover = (id, disableClickAway = false) => {
    const popover = document.getElementById(`${id}__popover`);
    const closeModal = () => {
        document.removeEventListener('click', clickAwayListener);
        document.removeEventListener('touchend', clickAwayListener);
        cleanupResizeOrientation();
        popover.classList.remove('show');
    };
    const clickAwayListener = (event) => {
        const targetElement = event.target || event.target;
        if (targetElement instanceof Element &&
            document.body.contains(targetElement) &&
            targetElement.closest(`#${id}`) == null &&
            !disableClickAway) {
            closeModal();
        }
    };
    // MAKE SURE NOTHING ELSE IS OPEN
    // closeModals();
    if (!popover.classList.contains('show')) {
        document.addEventListener('click', clickAwayListener);
        document.addEventListener('touchend', clickAwayListener);
        popover.classList.add('show');
        if (window.innerWidth <= 719) {
            document.body.style.position = 'absolute';
            document.body.style.overflow = 'hidden';
        }
    }
    else {
        popover.classList.remove('show');
        if (window.innerWidth <= 719) {
            document.body.style.position = null;
            document.body.style.overflow = null;
        }
    }
    const cleanupResizeOrientation = checkPopoverLocation(id);
};
export const checkPopoverLocation = (id) => {
    const popoverContent = document.getElementById(id);
    let timeOutFunctionId;
    const setLocation = () => {
        if (window.innerWidth > 719) {
            popoverContent.removeAttribute('style');
            const bounding = popoverContent.getBoundingClientRect();
            // Left side is out of viewoprt
            if (bounding.left < 0) {
                popoverContent.style.left = '0';
            }
            else {
                popoverContent.removeAttribute('style');
            }
            // Right side is out of viewport
            if (bounding.right >
                (window.innerWidth || document.documentElement.clientWidth)) {
                popoverContent.style.left = `calc(50% - ${bounding.right - window.innerWidth}px)`;
            }
            else {
                popoverContent.removeAttribute('style');
            }
        }
        else {
            popoverContent.removeAttribute('style');
        }
    };
    setLocation();
    const handleResize = () => {
        clearTimeout(timeOutFunctionId);
        timeOutFunctionId = setTimeout(() => setLocation(), 100);
    };
    const handleOrientationChange = () => {
        clearTimeout(timeOutFunctionId);
        timeOutFunctionId = setTimeout(() => setLocation(), 100);
    };
    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleOrientationChange);
    return () => {
        window.removeEventListener('resize', handleResize);
        window.removeEventListener('orientationchange', handleOrientationChange);
    };
};
/**
 * @param {string} selectedId - The ID of the popover that needs to stay open. If none is passed, all popovers will close
 */
export const closePopoverExcept = (selectedId) => {
    var _a, _b;
    (_a = document.querySelectorAll('.hds-m-popover')) === null || _a === void 0 ? void 0 : _a.forEach((elem) => {
        const popoverBlock = elem.querySelector('.hds-m-popover__block');
        if (!popoverBlock)
            return;
        const hasSelectedPopover = selectedId && selectedId !== elem.id;
        const closeAll = !selectedId && popoverBlock.classList.contains('show');
        if (hasSelectedPopover || closeAll)
            popoverBlock.classList.remove('show');
    });
    (_b = document.querySelectorAll('.hds-o-bottomSheet')) === null || _b === void 0 ? void 0 : _b.forEach((elem) => {
        const hasSelectedBottomSheet = selectedId && selectedId !== elem.id;
        const closeAll = !selectedId && !elem.classList.contains('hide');
        if (hasSelectedBottomSheet || closeAll)
            elem.classList.add('hide');
    });
};
export const closeAllPopover = () => {
    document.querySelectorAll('.hds-m-popover__block').forEach((elem) => {
        elem.classList.remove('show');
    });
};

//# sourceMappingURL=popover-utils.js.map
